import { BaseClient } from 'src/common-services/clients/base-client'

export class CensusClient extends BaseClient {
  getCountiesByIds(request: { ids: string[] }): Promise<Record<string, string>> {
    return this.call<Record<string, string>>('/census/counties', 'POST', { data: request })
  }
}
